class SimpleDataStore {
  constructor(value) {
    this.value = value;
  }
  get() {
    return this.value;
  }
  has() {
    return typeof this.value !== "undefined";
  }
  set(value) {
    this.value = value;
  }
  remove() {
    delete this.value;
  }
}
export {
  SimpleDataStore
};
//# sourceMappingURL=simple-data-store.js.map
